import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  padding: 16px;
  background: ${(props) => props.theme.colors.widget_background};
  border-radius: 12px;
  width: max-content;

  .widgets-container {
    display: flex;
    flex-direction: column;
  }

  .video-player-wrapper {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 16px;
    margin: 0px;
    overflow: hidden;
    width: 720px;
    min-height: 270px;
  }

  .video-player-wrapper.multiple {
    display: flex;
    flex-wrap: nowrap;
  }

  .no-video {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .video-slot {
    display: flex;
    flex: 0 0 calc(50% - 8px);
    width: calc(50% - 8px);
    max-width: calc(50% - 8px);
    height: 270px;
    min-width: 0;
    border-radius: 12px;
    overflow: hidden;

    > * {
      display: flex !important;
      margin-right: 0 !important;
      width: 100% !important;
      max-width: 100% !important;
      border-radius: 0 !important;
    }

    .video-player {
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;

      .plyr,
      .plyr__video-wrapper {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        height: 100% !important;
      }

      video {
        width: 100% !important;
        height: 100% !important;
        object-fit: cover !important;
      }
    }

    .video-placeholder {
      width: 100% !important;
    }
  }

  .video-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 270px;
    background-color: ${(props) => props.theme.colors.surface_muted};
    border-radius: 12px;
    color: ${(props) => props.theme.colors.text};
    font-size: 12px;
    text-align: center;

    .placeholder-message {
      color: ${(props) => props.theme.colors.inactive};
    }
  }

  .video-description {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 16px;
    margin-top: 16px;
    margin-bottom: 16px;
  }

  .info-cards {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .nav-container {
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: space-between;
    gap: 0px;
    padding: 0 4px 16px;
  }
  
  .nav-container>li{
    display: flex;
    flex: 1;
    justify-content: center;
  }

  .nav-container>li:hover {
    color: ${(props) => props.theme.colors.main_cta};
  }

  .nav-selected {
    display: flex;
    flex: 1;
    justify-content: center;
    border-bottom: solid;
    padding-bottom: 8px;
    color: ${(props) => props.theme.colors.main_cta};
    border-bottom-color: ${(props) => props.theme.colors.main_cta};
    border-bottom-width: 1px;
  }

  .nav-disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  .nav-container>li:hover .nav-disabled {
    color: inherit;
  }

  .icon-alerts {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: ${(props) => props.theme.colors.inactive};
    background-color: ${(props) => props.theme.colors.outline};
    border-radius: 12px;
    padding: 4px 8px;
  }
  
  .label-icon {
    color: ${(props) => props.theme.colors.innactive};
    padding: 8px 0 0 0;
    font-size: 12px;
  }
  
  .title-icon {
    padding: 4px 0 0 0;
    font-size: 12px;
  }

  .video-player {
    background-color: ${(props) => props.theme.colors.outline};
    justify-content: center;
  }

  .driver-photo-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 270px;
    background-color: ${(props) => props.theme.colors.outline};
    border-radius: 12px;
    overflow: hidden;
  }

  .driver-photo {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }

  .driver-photo-container .placeholder-message {
    color: ${(props) => props.theme.colors.inactive};
    font-size: 12px;
    text-align: center;
  }

  .video-slot .driver-photo-container {
    height: 100%;
    border-radius: 0;
  }

  .video-slot .driver-photo {
    border-radius: 0;
  }

`;

export default { Wrapper };
